import React from "react";
import styled from "styled-components";
import { IconContext } from "react-icons";
import { FaGithub, FaTwitter, FaYoutube, FaDiscord } from "react-icons/fa";
import { MdAdd, MdBrightness2, MdClose, MdExpandMore, MdArrowForward, MdInfoOutline, MdLanguage, MdMenu, MdSearch, MdWbSunny } from "react-icons/md";
import { BsQuestionSquareFill } from "react-icons/bs";
import { IoCodeDownload } from "react-icons/io5";

var Icon = function Icon(_ref) {
  var name = _ref.name,
      size = _ref.size,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(IconContext.Provider, {
    value: {
      size: size,
      className: className
    }
  }, name === "add" && /*#__PURE__*/React.createElement(MdAdd, null), name === "chevronDown" && /*#__PURE__*/React.createElement(MdExpandMore, null), name === "arrowRight" && /*#__PURE__*/React.createElement(MdArrowForward, null), name === "close" && /*#__PURE__*/React.createElement(MdClose, null), name === "darkTheme" && /*#__PURE__*/React.createElement(MdBrightness2, null), name === "github" && /*#__PURE__*/React.createElement(FaGithub, null), name === "info" && /*#__PURE__*/React.createElement(MdInfoOutline, null), name === "language" && /*#__PURE__*/React.createElement(MdLanguage, null), name === "lightTheme" && /*#__PURE__*/React.createElement(MdWbSunny, null), name === "menu" && /*#__PURE__*/React.createElement(MdMenu, null), name === "twitter" && /*#__PURE__*/React.createElement(FaTwitter, null), name === "search" && /*#__PURE__*/React.createElement(MdSearch, null), name === "youtube" && /*#__PURE__*/React.createElement(FaYoutube, null), name === "discord" && /*#__PURE__*/React.createElement(FaDiscord, null), name === "glossary" && /*#__PURE__*/React.createElement(BsQuestionSquareFill, null), name === "codeDownload" && /*#__PURE__*/React.createElement(IoCodeDownload, null));
};

Icon.defaultProps = {
  name: "",
  size: "24"
};
var StyledIcon = styled(Icon).withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "sc-1o8zi5s-0"
})(["fill:", ";&:hover path{fill:", ";}"], function (props) {
  return props.theme.colors.secondary;
}, function (props) {
  return props.theme.colors.primary;
});
export default StyledIcon;